import lrUser from './_src/lrUser.vue'
lrUser.install = function(Vue) {
  Vue.component(lrUser.name, lrUser)
}
export default lrUser